import React, { useEffect, useState } from "react";
import { Breadcrumb, Input, message, Select, Space, Spin, Tabs, Timeline } from "antd";
import { BackIcon } from "../../../asset";
import { t } from "i18next";
import style from "./CustomerAdd.module.css";
import PrimaryButton from "../../../component/button/PrimaryButton";
import SecondaryButton from "../../../component/button/SecondaryButton";
import { Navigate, useNavigate } from "react-router";
import { ROUTES } from "../../../constant/routeConstant";
import Accordion from "../../../component/accordion/Accordion";
import { AddIcon } from "../../../asset";
import MapsFullScreen from "../../../component/maps/MapsFullScreen";
import MapsSmall from "../../../component/maps/MapsSmall";
import axios from "axios";
import _ from "lodash";
import { useLocation } from "react-router-dom"
import { GROLOG_URL } from "../../../constant/apiConstant";
import Breadcumbs from '../../../component/page-components/breadcumbs/breadcumbs';
import { useDispatch, useSelector } from "react-redux";
import { validCustomer } from "./validation";
import Geocode from "react-geocode";
import ModalConfirmLeave from "../../../component/modal/ModalConfirmLeave";
import ModalSuccessAdd from "../../../component/modal/ModalSuccessAdd";
import ModalMaps from "../../../component/modal/ModalMaps";
import { onChanged } from "../../../util/Util";
import { LoadingOption, dropdownCustom, selectOption } from "../../../component/select/SelectOption";

const CustomerEdit = () => {
  const { token, client_id, grolog_account_id, userId } = useSelector((state) => state.auth);
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const api = GROLOG_URL
  const [isDataAddress, setisDataAddress] = useState([]);
  const [index, setIndex] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [detail, setDetail] = useState({})
  const location = useLocation()
  const [isData, setIsData] = useState([]);
  const [form, setForm] = useState([]);
  const [load, setLoad] = useState(false);
  const [addressFormat, setAddressFormat] = useState([]);
  const [change, setChange] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [country, setCountry] = useState([]);
  const [island, setIsland] = useState([]);
  const [province, setProvince] = useState([]);
  const [district, setDistrict] = useState([]);
  const [subdistrict, setSubdistrict] = useState([]);
  const [urbanvillage, setUrbanvillage] = useState([]);
  const [postalcode, setPostalcode] = useState([]);
  const [add, setAdd] = useState(true);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [changeAddress, setChangeAddress] = useState(false);
  const [longlat, setLonglat] = useState([])
  const [error, setError] = useState()
  const [c, setC] = useState("")
  const [i, setI] = useState("")
  const [p, setP] = useState("")
  const [d, setD] = useState("")
  const [s, setS] = useState("")
  const [u, setU] = useState("")
  const [pc, setPc] = useState("")
  const navigate = useNavigate();
  const [isOpenMaps, setIsOpenMaps] = useState(false)
  const dispatch = useDispatch()
  const [details, setDetails] = useState([]);
  const [radius, setRadius] = useState(0);
  const [isMax, setIsMax] = useState(false)
  const [errPostal, setErrPostal] = useState("")
  const [loc, setLoc] = useState("")
  const [loc2, setLoc2] = useState("")
  const [loading, setLoading] = useState(false)
  const [searchValue, setSearchValue] = useState("");
  const [pageCountry, setPageCountry] = useState(1);
  const [limitCountry, setLimitCountry] = useState(100);
  const [filter, setFilter] = useState("");
  const [pageProvince, setPageProvince] = useState(1);
  const [limitProvince, setLimitProvince] = useState(100);
  const [filterProvince, setFilterProvince] = useState("");
  const [pageDistrict, setPageDistrict] = useState(1);
  const [limitDistrict, setLimitDistrict] = useState(100);
  const [filterDistrict, setFilterDistrict] = useState("");
  const [pageSubdistrict, setPageSubdistrict] = useState(1);
  const [limitSubdistrict, setLimitSubdistrict] = useState(100);
  const [filterSubdistrict, setFilterSubdistrict] = useState("");
  const [pageUrbanvillage, setPageUrbanvillage] = useState(1);
  const [limitUrbanvillage, setLimitUrbanvillage] = useState(100);
  const [filterUrbanvillage, setFilterUrbanvillage] = useState("");

  const doPut = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "PUT";
    const headers = { "Authorization": tkn };
    const request = { url, method, headers, data };
    return axios(request);
  };


  useEffect(() => {
    fetchData();
  }, []);

  // const onSubmit = async () => {
  //   let sub = {
  //       // ...form,
  //       ...detail,
  //       // "customer_address": data,
  //     depot_id: 1,
  //     customer_id : location.state
  //   }
  //   let res = await doPut(`/customer/edit?${param}`, token, sub);
  //   message.success(_.startCase(res.data.payload.message));
  //   navigate({
  //     pathname: ROUTES.CUSTOMER.LIST,
  //     state: res.data.payload.message,
  //   });
  // };

  const actModal = () => {
    setSuccessModalOpen(false);
    navigate({
      pathname: ROUTES.CUSTOMER.LIST,
    });
  };

  const geocode = (address,idx, condition) => {
    setLoad(true);
    Geocode.setApiKey("AIzaSyC3m-M8TJAIH96lzjN2gDXHpyO1A2tTbsk");
    Geocode.fromAddress(address).then(
      (response) => {
        const { lat, lng } = response.results[0].geometry.location;

        const newDetail = [...isData];
        newDetail[index]["longitude"] = lng.toString();

        newDetail[index]["latitude"] = lat.toString();

        setIsData(newDetail);
        if (isData[index]?.address && !condition) {
          getPostalCode(lat, lng);
        }
        setLoad(false);
      },
      (error) => {
        console.error("geo eroer", error);
      }
    );
  };

  const getDistance = () => {
    var distanceService = new window.google.maps.DistanceMatrixService();

    // Define the origin and destination coordinates
    var origin = new window.google.maps.LatLng(
      Number(details?.depot_profile?.depot_latitude),
      Number(details?.depot_profile?.depot_longitude)
    );
    var destination = new window.google.maps.LatLng(
      Number(isData[index]?.latitude),
      Number(isData[index]?.longitude)
    );

    // Create a request object
    var request = {
      origins: [origin],
      destinations: [destination],
      travelMode: "DRIVING",
      unitSystem: window.google.maps.UnitSystem.METRIC,
    };

    // Call the getDistanceMatrix method of the DistanceMatrixService to get the distance
    distanceService.getDistanceMatrix(request, function (response, status) {
      if (status == "OK") {
        var distance = response.rows[0].elements[0].distance.text;
        setIsMax(response.rows[0].elements[0].distance.value / 1000 > radius)
      } else {
        console.log("Error:", status);
      }
    });
  };

  const handleChange = (value, name) => {

    onChanged(dispatch, true)
    if (name === "to_menu") {
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value,
        };
      });
    } else {
      setChange(true);
      let eror = validCustomer(name, value.target.value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [name]: value.target.value,
        };
      });
    }
  };

  const doPost = async (endpoint, tkn, data, dispatch, refresh_token) => {
    // const api = `http://app.sbp:9038/v1/grolog`;
    const api = GROLOG_URL;
    // const api = `http://app.sbp:9005/manager/v1/grolog`;
    let token =
      "eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJjaWQiOiIyYWM3ZjM5MGUzYjk0ODg3ODQ4NjkxMzViZDliNjI3OCIsInJlc291cmNlIjoiY2hhdCBkcml2ZSBsb2ciLCJzY29wZSI6InJlYWQgd3JpdGUiLCJsb2NhbGUiOiJpZC1JRCIsImV4cCI6MTY4MTM3OTEyNSwianRpIjoiODY0NzQ3MmI4MWU3NDMyMWFlMWM2ZjQxYmI3NTM2YjYiLCJpYXQiOjE2ODEyOTI3MjUsInN1YiI6IjQ4NjkyOCJ9.4DebpMNx03eb7a3WCh2hcLaxDsl9HjJl0Hbln9kMMv1au_mqHTRE5U72q28lzEjqqFYC1zbLFVDHn1HbhGlgSw";
    // if(validateExpired(token,dispatch,refresh_token)) {
    //   token = await doRefreshToken(token,dispatch);
    // }

    const url = api + endpoint;
    const method = "POST";
    const headers = {
      Authorization:
        "eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJjaWQiOiIyYWM3ZjM5MGUzYjk0ODg3ODQ4NjkxMzViZDliNjI3OCIsInJlc291cmNlIjoiY2hhdCBkcml2ZSBsb2ciLCJzY29wZSI6InJlYWQgd3JpdGUiLCJsb2NhbGUiOiJpZC1JRCIsImV4cCI6MTY4MTI5MzMzNywianRpIjoiMmJlZGUxZDI3YjQ0NDc5NDg0ZDgxNjBhYWNhYmM4N2IiLCJpYXQiOjE2ODEyMDY5MzcsInN1YiI6IjQ4NjkyOCJ9.NqfsYPH8LYtaB1RusdGKgIrg6gQEUb9u6hrIQwvbN_-MAGqa68501CDsEdzyMxBFSU5LuZNTmyfSgvZa9_XTug",
    };
    const request = { url, method, headers, data };
    return axios(request);
  };

  const doGetPostalCode = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const url = GROLOG_URL + endpoint;
    const method = "POST";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, data };
    return axios(request);
  };

  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    // const api = `http://app.sbp:9038/v1/grolog`;
    const api = GROLOG_URL;
    let token =
      "eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJjaWQiOiIyYWM3ZjM5MGUzYjk0ODg3ODQ4NjkxMzViZDliNjI3OCIsInJlc291cmNlIjoiY2hhdCBkcml2ZSBsb2ciLCJzY29wZSI6InJlYWQgd3JpdGUiLCJsb2NhbGUiOiJpZC1JRCIsImV4cCI6MTY4MTM3OTEyNSwianRpIjoiODY0NzQ3MmI4MWU3NDMyMWFlMWM2ZjQxYmI3NTM2YjYiLCJpYXQiOjE2ODEyOTI3MjUsInN1YiI6IjQ4NjkyOCJ9.4DebpMNx03eb7a3WCh2hcLaxDsl9HjJl0Hbln9kMMv1au_mqHTRE5U72q28lzEjqqFYC1zbLFVDHn1HbhGlgSw";
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const doGets = async (endpoint, tknn, params, dispatch, refresh_token) => {
    // const api = `http://app.sbp:9005/manager/v1/grolog`;
    const api = GROLOG_URL;
    let token =
      "eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJjaWQiOiIyYWM3ZjM5MGUzYjk0ODg3ODQ4NjkxMzViZDliNjI3OCIsInJlc291cmNlIjoiY2hhdCBkcml2ZSBsb2ciLCJzY29wZSI6InJlYWQgd3JpdGUiLCJsb2NhbGUiOiJpZC1JRCIsImV4cCI6MTY4MTQ3NzM1MywianRpIjoiMDE1YWMwZjBjYjA0NDUyNWE3NDk4YmE1MmRjODc5ODciLCJpYXQiOjE2ODEzOTA5NTMsInN1YiI6IjQ4NjkyOCJ9.QuFfquiR-0gvsRRFvK12b9ynZ7xTWNCxglJuf1fqGL4IA-2hG5Mntc4JO6KU-sQtLi_swdaT3yY3ae5Jg_etYA";
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: tknn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  let tknn = token
  const fetchData = async (data) => {
    //  setLoad(true);
    let res = await doGet(
      `/address-format-configuration?page=1&limit=10?${param}`,
      token
    );
    let res2 = await doGet(
      `/customer/${location.state}`, token
    );
    if (res2?.data?.payload?.data?.phone.includes("+")) {
      let newdetail = res2?.data?.payload?.data
      let phone = res2?.data?.payload?.data?.phone.substring(4);
      newdetail["phone"] = phone
      setForm(newdetail)
    }
    setForm(res2?.data?.payload?.data);
    let list = []
    res2?.data?.payload?.data?.customer_address.map((el) => {
      list.push({
        recipient_name: el.recipient_name,
        recipient_phone: el.recipient_phone,
        address_id: el.address_id,
        updated_at: el.updated_at,
        country_id: el.countryId,
        province_id: el.provinceId,
        island_id: el.islandId,
        district_id: el.districtId,
        sub_district_id: el.subDistrictId,
        urban_village_id: el.urbanVillageId,
        postal_code: el.postal_code_id,
        longitude: el.longitude,
        latitude: el.latitude,
        hamlet: el.hamlet,
        neighbourhood: el.neighbourhood,
        address: el.address,
        is_deleted: false
      })
    })
    setIsData(list)
    getListCountry(1,100,"");
    setAddressFormat(
      res?.data?.payload?.data?.ListAddressFormatConfiguration?.map(
        (el) => el?.mandatory
      )?.findIndex((cek) => cek === "No")
    );
    let result = await doGet(
      `/depot-configuration/${res2?.data?.payload?.data?.depot_id}?${param}`,
      token
    );
    setDetails(result?.data?.payload?.data);
    setRadius(Number(result?.data?.payload?.data?.system_preferences?.max_range?.split(" ")[0]))
    // let resParam = await doGet(
    //   `/grolog-parameter?page=1&limit=100&order=id asc&${param}`,
    //   token
    // );
    // let resDetail = await doGet(
    //   `/grolog-parameter/${
    //     resParam?.data?.payload?.data[
    //       resParam?.data?.payload?.data?.findIndex(
    //         (el) => el.parameter_code === "@MaxOrderRadius"
    //       )
    //     ]?.id
    //   }?${param}`,
    //   token
    // );
    // setRadius(Number(resDetail?.data?.payload?.char_value));
    // setLoad(false);
  };
const isZero=[]
  const getListCountry = async (page, limit, filter) => {

    const currentCountry = [...country];
    let countrys = await doGets(
      `/country?page=${page}&limit=${limit}${filter ? `&filter=name lk ${filter}`:""
      }&${param}`,
      token
    );
    let option = [];
    let list = countrys?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      setCountry(selectOption(currentCountry, option, "value"));
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListIsland = async (id) => {
    let island = await doGets(
      `/island?page=1&limit=50&order=id&filter=country_id eq ${id}&${param}`,
      tknn
    );
    let list = [];
    island?.data?.payload?.data.map((el) => {
      list.push({
        value: el.id,
        label: el.name,
      });
    });
    setIsland(list);
  };

  const getListProvince = async (id, page, limit, filter,isChange) => {
    const currentProvince = [...province];
    let provinces = await doGets(
      `/province?page=${page}&limit=${limit}&filter=country_id eq ${id}${filter ? `, name lk ${filter}`:""
      }&${param}`,
      token
    );
    let option = [];
    let list = provinces?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if(isChange){
        setProvince(selectOption(isZero, option, "value"));
        }else{
        setProvince(selectOption(currentProvince, option, "value"));
        }
      setLoading(false);
    } else {
      setLoading(false);
    }
  };
  
const getListDistrict = async (id, idprov,page, limit, filter,isChange ) => {

    const currentDistrict = [...district];
    let districts = await doGets(
      `/district?page=${page}&limit=${limit}&filter=country_id eq ${id}, province_id eq ${idprov}${filter ? `, name lk ${filter}`:""
      }&${param}`,
      token
    );
    let option = [];
    let list = districts?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if(isChange){
        setDistrict(selectOption(isZero, option, "value"));
        }else{
        setDistrict(selectOption(currentDistrict, option, "value"));
        }setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListSubdistrict = async (id, idprov, page, limit, filter,isChange) => {
    const currentSubdistrict = [...subdistrict];
    let districts = await doGets(
      `/sub_district?page=${page}&limit=${limit}&filter=country_id eq ${id}, district_id eq ${idprov}${filter ? `, name lk ${filter}`:""
      }&${param}`,
      token
    );
    let option = [];
    let list = districts?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if(isChange){
        setSubdistrict(selectOption(isZero, option, "value"));
        }else{
        setSubdistrict(selectOption(currentSubdistrict, option, "value"));
        }setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListUrbanvillage = async (id, idprov, page, limit, filter,isChange) => {
    const currentUrbanvillage = [...urbanvillage];
    let districts = await doGets(
      `/urban_village?page=${page}&limit=${limit}&filter=country_id eq ${id}, sub_district_id eq ${idprov}${filter ? `, name lk ${filter}`:""
      }&${param}`,
      token
    );
    let option = [];
    let list = districts?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if(isChange){
        setUrbanvillage(selectOption(isZero, option, "value"));
        }else{
        setUrbanvillage(selectOption(currentUrbanvillage, option, "value"));
        }setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListPostalCode = async (id, idprov) => {
    let district = await doGets(
      `/postal_code?page=1&limit=50&order=id&filter=urban_village_id eq ${id}&${param}`,
      tknn
    );
    let list = [];
    district?.data?.payload?.data.map((el) => {
      list.push({
        value: el.id,
        label: el.code,
      });
    });
    setPostalcode(list);
  };


  const validateSubmit = (error) => {
    for (const key in error) {
      if (Object.hasOwnProperty.call(error, key)) {
        if (error[key]) return false;
      }
    }
    return true;
  };


  const onSubmit = async () => {
    let sub = {
      ...form,
      phone: "+62-" + form.phone,
      customer_address: isData,
      depot_id: form?.depot_id,
    };
    let errors = {};
    let datacheck = {
      first_name: form.first_name ? form.first_name : "",
      last_name: form.description ? form.description : "",
      email: form.email ? form.email : "",
      phone: form.phone ? form.phone : "",
      fax: form.fax ? form.fax : "",
    };
    for (const key in datacheck) {
      const option = validCustomer(key, datacheck[key], t);
      // let option = validUserProfile(key, value[key], this.props.t);
      const currentError = option;
      errors = { ...currentError, ...errors };
    }
    setError(errors);
    if (validateSubmit(errors)) {
      try {
        let tkn = token;

        let param =
          "CLIENT_ID=1231278asdbaiaerrs&RESOURCE_USER_ID=13&GROLOG_ACCOUNT_ID=1";
        let res = await doPut(`/customer/${location.state}?${param}`, tkn, sub);
        setSuccessModalOpen(true);
      } catch (err) {
        if (
          err.response.data.payload.message ===
          "Data with this Additional Name is already used by other, cant process this action"
        ) {
          // setErr(err.response.data.payload.message)
        } else {
          message.error(_.startCase(err.response.data.payload.message));
        }
      }
    }
  };
  // let data = [
  //   {
  //     country_id: 1,
  //     island_id: 1,
  //     province_id: 1,
  //     district_id: 1,
  //     sub_district_id: 1,
  //     urban_village_id: 1,
  //     address: "Jl. Kemurnian 1 no. 11",
  //     neighbourhood: "001",
  //     hamlet: "002",
  //     postal_code: "15615",
  //     longitude: "127.1",
  //     latitude: "-6.5",
  //   },
  // ];

  const addRows = (e) => {
    setAdd(false);
    setChangeAddress(true);
    setIsData([
      ...isData,
      {
        recipient_name: '',
        recipient_phone: '',
        country_id: "",
        island_id: 0,
        province_id: "",
        district_id: "",
        sub_district_id: "",
        urban_village_id: "",
        address: "",
        neighbourhood: "",
        hamlet: "",
        postal_code: "",
        longitude: "",
        latitude: "",
      },
    ]);
  };
  
  const handleChangeAddress = (i, index, e, tes) => {
    onChanged(dispatch, true)
    const newDetail = [...isData];
    const isChange=true
    setChange(true);
    setChangeAddress(true);
    if (e === "longitude" || e === "latitude") {
      let eror = validCustomer(e, i.target.value, t);
      setError({ ...error, ...eror });
      newDetail[index][e] = i.target.value;
    } else if (e === "country_id") {
      setLonglat([])
      setIsland([]);
      setProvince([]);
      setDistrict([]);
      setSubdistrict([]);
      setUrbanvillage([]);
      setPostalcode([]);
      getListIsland(i);
      setSearchValue("")
      setFilter("")
      getListProvince(i,1,100,"",isChange);
      let eror = validCustomer(e, i, t);
      setError({ ...error, ...eror });
      newDetail[index][e] = i;
      newDetail[index]["island_id"] = 0;
      newDetail[index]["province_id"] = "";
      newDetail[index]["district_id"] = "";
      newDetail[index]["sub_district_id"] = "";
      newDetail[index]["urban_village_id"] = "";
      newDetail[index]["islandId"] = 0;
      newDetail[index]["provinceId"] = "";
      newDetail[index]["districtId"] = "";
      newDetail[index]["subDistrictId"] = "";
      newDetail[index]["urbanVillageId"] = "";
      newDetail[index]["postal_code"] = "";
      newDetail[index]["address"] = "";
      setC(country[country.findIndex((el) => el.props.value === i)]?.props?.children)
      let lnglat = country[country.findIndex((el) => el.props.value === i)]?.props?.children;
      geocode(lnglat, index, true);
      setLonglat(country[country.findIndex((el) => el.props.value === i)]?.props?.children)
    } else if (e === "island_id") {
      setI([...longlat, island[island.findIndex((el) => el.value === i)].label])
      // getListProvince(i);
      newDetail[index][e] = i;
    } else if (e === "province_id") {
      setDistrict([]);
      setSubdistrict([]);
      setUrbanvillage([]);
      setPostalcode([]);
      setSearchValue("")
      setFilter("")
      getListDistrict(isData[index].country_id, i,1,100,"",isChange);
      let eror = validCustomer("e", i, t);
      setError({ ...error, ...eror });
      newDetail[index][e] = i;
      newDetail[index]["district_id"] = "";
      newDetail[index]["sub_district_id"] = "";
      newDetail[index]["urban_village_id"] = "";
      newDetail[index]["districtId"] = "";
      newDetail[index]["subDistrictId"] = "";
      newDetail[index]["urbanVillageId"] = "";
      newDetail[index]["postal_code"] = "";
      newDetail[index]["address"] = "";
      console.log("prov", province);
      console.log("cek province", province[province.findIndex((el) => el.props.value === i)]?.props?.children);
      setP(province[province.findIndex((el) => el.props.value === i)]?.props?.children)
      let lnglat =
        c + "," + province[province.findIndex((el) => el.props.value === i)]?.props?.children;

      geocode(lnglat, index,true);
    } else if (e === "district_id") {
      setSubdistrict([]);
      setUrbanvillage([]);
      setPostalcode([]);
      setSearchValue("")
      setFilter("")
      getListSubdistrict(isData[index].country_id, i,1,100,"",isChange);
      let eror = validCustomer("e", i, t);
      setError({ ...error, ...eror });
      newDetail[index][e] = i;
      newDetail[index]["sub_district_id"] = "";
      newDetail[index]["urban_village_id"] = "";
      newDetail[index]["subDistrictId"] = "";
      newDetail[index]["urbanVillageId"] = "";
      setD(district[district.findIndex((el) => el?.props?.value === i)].props?.children);
      newDetail[index]["postal_code"] = "";
      newDetail[index]["address"] = "";
      let lnglat =
        c +
        "," +
        p +
        "," +
        district[district.findIndex((el) => el?.props?.value === i)].props?.children;
      geocode(lnglat, index, true);

    } else if (e === "sub_district_id") {
      setUrbanvillage([]);
      setSearchValue("")
      setFilter("")
      setPostalcode([]);
      getListUrbanvillage(isData[index].country_id, i,1,100,"",isChange);
      let eror = validCustomer("e", i, t);
      setError({ ...error, ...eror });
      newDetail[index][e] = i;
      newDetail[index]["urban_village_id"] = "";
      newDetail[index]["urbanVillageId"] = "";
      // newDetail[index]["address"] = "";
      setS(subdistrict[subdistrict.findIndex((el) => el?.props?.value === i)].props?.children);
      // newDetail[index]["postal_code"] = "";
      let lnglat =
        c +
        "," +
        p +
        "," +
        d +
        "," +
        subdistrict[subdistrict.findIndex((el) => el?.props?.value === i)].props?.children;
      // geocode(lnglat, index);
    } else if (e === "urban_village_id") {
      setPostalcode([]);
      getListPostalCode(i);
      let eror = validCustomer("e", i, t);
      setError({ ...error, ...eror });
      newDetail[index][e] = i;
      // newDetail[index]["address"] = "";
      setU(
        urbanvillage[urbanvillage.findIndex((el) => el?.props?.value === i)].props?.children
      );
      // newDetail[index]["postal_code"] = "";
      let lnglat =
        c +
        "," +
        p +
        "," +
        d +
        "," +
        s +
        "," +
        urbanvillage[urbanvillage.findIndex((el) => el?.props?.value === i)].props?.children;
      // geocode(lnglat, index);
    } else if (e === "postal_code") {
      let eror = validCustomer("e", i.target.value, t);
      setError({ ...error, ...eror });
      newDetail[index][e] = Number(i.target.value);
      // if(addressFormat<0){
      // let lnglat = (c+","+p+","+d+","+s+","+u+","+i+" "+isData[index]?.address)
      // geocode(lnglat,index)
      // }
    } else if (e === "address") {
      // if(addressFormat >=1){
      let eror = validCustomer(e, i.target.value, t);
      setError({ ...error, ...eror });
      newDetail[index][e] = i.target.value;

      // if (addressFormat<0) {
      //   let lnglat = (c+","+p+","+d+","+s+","+u+","+i.target.value)
      //   geocode(lnglat, index);
      // }
    } else if (e === "recipient_phone") {
      let eror = validCustomer(e, i.target.value, t);
      setError({ ...error, ...eror });
      newDetail[index][e] = `+62-${i.target.value}`;
    } else {
      let eror = validCustomer(e, i.target.value, t);
      setError({ ...error, ...eror });
      newDetail[index][e] = i.target.value;
    }
    setIsData(newDetail);
  };

  const actionBlur = (i) => {
    // if (addressFormat < 0) {
    // let lnglat =
    //   c + "," + p + "," + d + "," + s + "," + u + "," + isData[i]?.address;
    let lnglat = isData[i]?.address
    geocode(lnglat, index);
    
    // }
  };

  const onBlurPostal = () => {
    getRegionByPostalCode(isData[index]?.postal_code, s, u)
  }

  const getPostalCode = (latitude, longitude) => {
    const geocoder = new window.google.maps.Geocoder();
    const latLng = new window.google.maps.LatLng(latitude, longitude);

    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === window.google.maps.GeocoderStatus.OK && results[0]) {
        for (let i = 0; i < results[0].address_components.length; i++) {
          const component = results[0].address_components[i];
          if (component.types.includes("postal_code")) {

            let eror = validCustomer("postal_code", component.long_name, t);
            setError({ ...error, ...eror });
            const newDetail = [...isData];
            newDetail[index]["postal_code"] = Number(component.long_name);
            if(isData[index]?.address){
              getRegionByPostalCode(component.long_name, s, u);
              }
            return; // Exit the loop if postal code is found
          }
        }
        const newDetail = [...isData];
        newDetail[index]["postal_code"] = ""

        setIsData(newDetail);
        console.log("Postal code not found.");
      } else {
        console.log("Geocoder failed due to:", status);
      }
    });
  };

  const getRegionByPostalCode = async (code, subDistrict, urbanVillage) => {
    try {
      // let region = await doGets(`/postal_code/${code}`, token);
      let data ={
        "sub_district": subDistrict,
        "urban_village": urbanVillage
      }
      let region = await doGetPostalCode(`/postal_code/${code}`, token, data);
      let list = [];
      const newDetail = [...isData]
      let reg = region?.data?.payload?.data
      getListCountry(1,100,"")
      getListProvince(reg?.country_id,1,100,"");
      getListDistrict(reg?.country_id, reg?.province_id,1,100,"",true)
      getListSubdistrict(reg?.country_id, reg?.district_id,1,100,"",true)
      getListUrbanvillage(reg?.country_id, reg?.sub_district_id,1,100,"", true)
      newDetail[index]["country_id"] = reg?.country_id;
      newDetail[index]["province_id"] = reg?.province_id;
      newDetail[index]["district_id"] = reg?.district_id;
      newDetail[index]["sub_district_id"] = reg?.sub_district_id;
      newDetail[index]["urban_village_id"] = reg?.urban_village_id;
      setErrPostal("")
      setC(reg?.country_name)
      setP(reg?.province_name)
      setD(reg?.district_name)
      setS(reg?.sub_district_name)
      setU(reg?.urban_village_name)
      let lnglat = reg?.country_name + "," + reg?.province_name + "," + reg?.district_name + "," + reg?.sub_district_name + "," + reg?.urban_village_name + "," + code

      // geocode(lnglat, index);
    } catch (err) {
      try {
        // let region = await doGets(`/postal_code/${code}`, token);
        let data ={
          "sub_district": "",
          "urban_village": ""
        }
        let region = await doGetPostalCode(`/postal_code/${code}`, token, data);
        let list = [];
        const newDetail = [...isData]
        let reg = region?.data?.payload?.data
        getListCountry(1,100,"")
        getListProvince(reg?.country_id,1,100,"");
        getListDistrict(reg?.country_id, reg?.province_id,1,100,"", true)
        getListSubdistrict(reg?.country_id, reg?.district_id,1,100,"",true)
        getListUrbanvillage(reg?.country_id, reg?.sub_district_id,1,100,"", true)
        newDetail[index]["country_id"] = reg?.country_id;
        newDetail[index]["province_id"] = reg?.province_id;
        newDetail[index]["district_id"] = reg?.district_id;
        newDetail[index]["sub_district_id"] = reg?.sub_district_id;
        newDetail[index]["urban_village_id"] = reg?.urban_village_id;
        setErrPostal("")
        setC(reg?.country_name)
        setP(reg?.province_name)
        setD(reg?.district_name)
        setS(reg?.sub_district_name)
        setU(reg?.urban_village_name)
        let lnglat = reg?.country_name + "," + reg?.province_name + "," + reg?.district_name + "," + reg?.sub_district_name + "," + reg?.urban_village_name + "," + code
  
        // geocode(lnglat, index);
      } catch (err) {
        if (err.response.data.payload.code === "E-4-CMD-DTO-004") {
          setErrPostal("Postal Code not found")
        }
      }
    }

  };

  const removeAddress = (i) => {
    let newDetail = [...isData];
    // newDetail.splice(i, 1);

    newDetail[i]["is_deleted"] = true;
    setIsData(newDetail);
    setChangeAddress(false);
    if (isData.length === 0 || isData.length - 1 === i) {
      setAdd(true);
    }
  };

  const addAddress = (i) => {
    getDistance()
    let errors = {};
    let sub = isData[i];
    for (const key in sub) {
      const option = validCustomer(key, sub[key], t);
      const currentError = option;
      errors = { ...currentError, ...errors };
    }
    setError(errors);
    if (validateSubmit(errors) && !isMax) {
      setAdd(true);
      setIsOpen(false);
      setChangeAddress(false);
    }
  };

  const AddressForm = (i) => {
    return (
      <>
        {isData[i].map((el) => {
          return (
            <>
              <div className="h-[300px] bg-white-100 opacity-100 rounded-lg ">
                {el.address}
              </div>
            </>
          );
        })}
      </>
    );
  };

  const clickCard = (i, open) => {
    setIndex(i);
    setIsOpen(isOpen ? false : true);
    // if(!isOpen){
    getListCountry(1,100,"")
    getListIsland(isData[i].country_id ? isData[i].country_id : isData[i].countryId,1,100,"")
    getListProvince(isData[i].country_id ? isData[i].country_id : isData[i].countryId,1,100,"")
    getListDistrict(isData[i].country_id ? isData[i].country_id : isData[i].countryId, isData[i].province_id ? isData[i].province_id : isData[i].provinceId,1,100,"")
    getListSubdistrict(isData[i].country_id ? isData[i].country_id : isData[i].countryId, isData[i].district_id ? isData[i].district_id : isData[i].districtId,1,100,"")
    getListUrbanvillage(isData[i].country_id ? isData[i].country_id : isData[i].countryId, isData[i].sub_district_id ? isData[i].sub_district_id : isData[i].subDistrictId,1,100,"")
    getListPostalCode(isData[i].urban_village_id ? isData[i].urban_village_id : isData[i].urbanVillageId,1,100,"")
    setC(form?.customer_address[i].country)
    setP(form?.customer_address[i].province)
    setD(form?.customer_address[i].district)
    setS(form?.customer_address[i].sub_district)
    setU(form?.customer_address[i].urban_village)
    // }
  };
  const toMapsFull = (el, i) => {
    navigate(ROUTES.CUSTOMER.MAPS, { state: el, address: isData[i]?.address });
  };

  const onScrollCountry = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      console.log("sini g");
      setPageCountry(pageCountry + 1);
      target.scrollTo(0, target.scrollHeight);
      getListCountry(pageCountry, limitCountry,"");
      // setTimeout(() => {
      //   getListCountry(pageCountry,limitCountry)
      // }, 256);
    }
  };

  const onChangeCountry = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setCountry([]);
      setPageCountry(resetPage);
      // this.setState(
      setTimeout(() => {
        getListCountry(pageCountry, limitCountry, filter);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setCountry([]);
      setFilter(resetFilter);
      setPageCountry(resetPage);
      getListCountry(pageCountry, limitCountry, filter);
    }
  };

  const onScrollProvince = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      console.log("sini g");
      setPageProvince(pageProvince + 1);
      target.scrollTo(0, target.scrollHeight);
      getListProvince(isData[index]["country_id"], pageProvince, limitProvince, "");
      // setTimeout(() => {
      //   getListProvince(pageProvince,limitProvince)
      // }, 256);
    }
  };

  const onChangeProvince = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setProvince([]);
      setPageProvince(resetPage);
      // this.setState(
      setTimeout(() => {
        getListProvince(isData[index]["country_id"], pageProvince, limitProvince, filter);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setProvince([]);
      setFilter(resetFilter);
      setPageProvince(resetPage);
      getListProvince(isData[index]["country_id"], pageProvince, limitProvince, filter);
    }
  };

  const onScrollDistrict = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      console.log("sini g");
      setPageDistrict(pageDistrict + 1);
      target.scrollTo(0, target.scrollHeight);
      getListDistrict(isData[index]["country_id"], isData[index]["province_id"], pageDistrict, limitDistrict, "");
      // setTimeout(() => {
      //   getListDistrict(pageDistrict,limitDistrict)
      // }, 256);
    }
  };

  console.log("searchv", searchValue);
  const onChangeDistrict = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setDistrict([]);
      setPageDistrict(resetPage);
      // this.setState(
      setTimeout(() => {
        getListDistrict(isData[index]["country_id"], isData[index]["province_id"], pageDistrict, limitDistrict, filter);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setDistrict([]);
      setFilter(resetFilter);
      setPageDistrict(resetPage);
      getListDistrict(isData[index]["country_id"], isData[index]["province_id"], pageDistrict, limitDistrict, filter);
    }
  };
  const onScrollSubdistrict = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      console.log("sini g");
      setPageSubdistrict(pageSubdistrict + 1);
      target.scrollTo(0, target.scrollHeight);
      getListSubdistrict(isData[index]["country_id"], isData[index]["district_id"], pageSubdistrict, limitSubdistrict, "");
      // setTimeout(() => {
      //   getListSubdistrict(pageSubdistrict,limitSubdistrict)
      // }, 256);
    }
  };

  const onChangeSubdistrict = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setSubdistrict([]);
      setPageSubdistrict(resetPage);
      // this.setState(
      setTimeout(() => {
        getListSubdistrict(isData[index]["country_id"], isData[index]["district_id"], pageSubdistrict, limitSubdistrict, filter);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setSubdistrict([]);
      setFilter(resetFilter);
      setPageSubdistrict(resetPage);
      getListSubdistrict(isData[index]["country_id"], isData[index]["district_id"], pageSubdistrict, limitSubdistrict, filter);
    }
  };
  const onScrollUrbanvillage = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      console.log("sini g");
      setPageUrbanvillage(pageUrbanvillage + 1);
      target.scrollTo(0, target.scrollHeight);
      getListUrbanvillage(isData[index]["country_id"], isData[index]["sub_district_id"], pageUrbanvillage, limitUrbanvillage, "");
      // setTimeout(() => {
      //   getListUrbanvillage(pageUrbanvillage,limitUrbanvillage)
      // }, 256);
    }
  };

  const onChangeUrbanvillage = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setUrbanvillage([]);
      setPageUrbanvillage(resetPage);
      // this.setState(
      setTimeout(() => {
        getListUrbanvillage(isData[index]["country_id"], isData[index]["sub_district_id"], pageUrbanvillage, limitUrbanvillage, filter);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setUrbanvillage([]);
      setFilter(resetFilter);
      setPageUrbanvillage(resetPage);
      getListUrbanvillage(isData[index]["country_id"], isData[index]["sub_district_id"], pageUrbanvillage, limitUrbanvillage, filter);
    }
  };
  //end country
  const getAdr = (long,latt) => {
    const geocoder = new window.google.maps.Geocoder();
    const latLng = new window.google.maps.LatLng(latt, long);

    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === window.google.maps.GeocoderStatus.OK && results[0]) {
        for (let i = 0; i < results[0].address_components.length; i++) {
          const component = results[0].address_components[i];
          if (component.types.includes("administrative_area_level_3")) {
            setLoc(component.long_name)
            return; // Exit the loop if postal code is found
          }if(component.types.includes("administrative_area_level_4")){
            setLoc2(component.long_name)
          }
        }
      
      } else {
        console.log("Geocoder failed due to:", status);
      }
  })

  setIsOpenMaps(true)
}

  return (
    <>

      {/* <MapsCustom
    visible = {true}
    width={1000}
    /> */}

      <ModalConfirmLeave
        visible={showConfirm}
        action={() => setShowConfirm(false)}
        route={ROUTES.CUSTOMER.LIST}
      />
      <ModalSuccessAdd
        show={successModalOpen}
        action={() => actModal()}
        closable={false}
        width={280}
        className={style.deleteModal}
        okText="Ok"
        title="Success"
        description="Your data has been updated"
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <Breadcumbs
          jmlLevel={3}
          menuLevel1={`Master`}
          menuLevel2={`Customer`}
          menuLevel3={`Edit ` + form.customer_id + ` - ` + form.first_name + ` ` + form.last_name}
        />

        <div className="flex items-center justify-between">
          <div
            onClick={
              change
                ? () => setShowConfirm(true)
                : () => navigate(ROUTES.CUSTOMER.LIST)
            }
            className="flex items-center gap-[22px] cursor-pointer"
          >
            <img src={BackIcon} alt="" className="cursor-pointer" />

            <h1 className="font-sans-bold text-2xl" id="title">
              Edit {form.customer_id} - {form.first_name + " " + form.last_name}
            </h1>
          </div>
        </div>

        <div
          onClick={() => (isData[index]?.latitude ? getDistance() : "")}
          style={{
            marginTop: 24,
            padding: 30,
            minHeight: 512,
            borderRadius: "6px",
            backgroundColor: "white",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
          }}
        >
          <div className="flex">
            <div>
              <h3 className="font-roboto text-lg font-medium mb-6 mt-2">
                {t("CUSTOMER:CUSTOMER_INFO")}
              </h3>
              <div className="flex">
                {/* line one */}
                <div className="gap-[40px] mb-[24px]">
                  <div className="w-[500px] mb-[24px]">
                    <label className="font-roboto text-base font-medium">
                      {t("CUSTOMER:FIRST_NAME")}
                    </label>
                    <Input
                      status={error?.first_name ? "error" : ""}
                      className="mt-[8px] h-[47px] w-[500px]"
                      placeholder="Type First Name"
                      value={form.first_name}
                      onChange={(value) => handleChange(value, "first_name")}
                    />
                    <div className="text-red-100">{error?.first_name}</div>
                  </div>
                  <div className="w-[500px] mb-[24px]">
                    <label className="font-roboto text-base font-medium">
                      {t("CUSTOMER:LAST_NAME") + " (Optional)"}
                    </label>
                    <Input
                      status={error?.last_name ? "error" : ""}
                      className="mt-[8px] h-[47px] w-[500px]"
                      value={form.last_name}
                      placeholder="Type Last Name"
                      onChange={(value) => handleChange(value, "last_name")}
                    />
                    <div className="text-red-100">{error?.last_name}</div>
                  </div>
                  <div className="w-[500px] mb-[24px]">
                    <label className="font-roboto text-base font-medium">
                      {t("CUSTOMER:EMAIL") + " (Optional)"}
                    </label>
                    <Input
                      status={error?.email ? "error" : ""}
                      placeholder="Type Email"
                      value={form.email}
                      className="mt-[8px] h-[47px] w-[500px]"
                      onChange={(value) => handleChange(value, "email")}
                    />
                    <div className="text-red-100">{error?.email}</div>
                  </div>
                </div>

                {/* LINE TWO */}
                <div className="gap-[40px] mb-[24px] ml-36">
                  <div className="w-[500px] mb-[24px]">
                    <label className="font-roboto text-base font-medium">
                      {t("CUSTOMER:PHONE")}
                    </label>
                    <Space.Compact>
                      <Input
                        style={{ width: "15%" }}
                        defaultValue="+62"
                        disabled
                      />
                      <Input
                        style={{ width: "480px", height: "47px" }}
                        onChange={(value) => handleChange(value, "phone")}
                        status={error?.phone ? "error" : ""}
                        value={form.phone}
                      />
                    </Space.Compact>
                    <div className="text-red-100">{error?.phone}</div>
                  </div>
                  <div className="w-[500px] mb-[24px]">
                    <label className="font-roboto text-base font-medium">
                      {t("CUSTOMER:FAX") + " (Optional)"}
                    </label>
                    <Space.Compact>
                      <Input
                        style={{ width: "15%" }}
                        defaultValue="+62"
                        disabled
                      />
                      <Input
                        style={{ width: "480px", height: "47px" }}
                        status={error?.fax ? "error" : ""}
                        placeholder="Type Fax"
                        onChange={(value) => handleChange(value, "fax")}
                        value={form?.fax}
                      />
                    </Space.Compact>
                    <div className="text-red-100">{error?.fax}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Accordion add address */}
          {isData.map((el, i) => {
            return (
              <>
                {
                  !el?.is_deleted ?
                    <>
                      <div id={i}>
                        <Accordion
                          onClick={() => clickCard(i, isOpen)}
                          index={i}
                          i={index}
                          isOpen={isOpen}
                          address={el.address}
                          body={
                            <>
                              {isOpen === true && i === index ? (
                                <>
                                  <ModalMaps show={isOpenMaps}
                            loc={loc+", "+(loc2 ? loc2 + ", ":"")+el.longitude+", "+el.latitude}
                                    address={el.address}
                                    latitude={el.latitude}
                                    longitude={el.longitude}
                                    onClose={() => setIsOpenMaps(false)}
                                  />
                                  <div className="h-auto bg-white-100 opacity-100 rounded-b-lg p-4">
                                    <div className="flex">
                                      <div>
                                        <div className="flex">
                                          {/* line one */}
                                          <div className="gap-[40px] mb-[24px]">
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-base font-medium">
                                                {'Recipient\'s Name'}
                                              </label>
                                              <Input
                                                status={
                                                  error?.recipient_name
                                                    ? "error"
                                                    : ""
                                                }
                                                placeholder="Type Recipient's Name"
                                                className="mt-[8px] h-[47px] w-[500px]"
                                                defaultValue={el.recipient_name}
                                                onChange={(value) =>
                                                  handleChangeAddress(
                                                    value,
                                                    i,
                                                    "recipient_name"
                                                  )
                                                }
                                              />
                                              <div className="text-red-100 text-[12px]">
                                                {error?.recipient_name}
                                              </div>
                                            </div>

                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-base font-medium">
                                                {'Recipient\'s Phone'}
                                              </label>
                                              <Space.Compact>
                                                <Input
                                                  style={{ width: "15%", marginTop: "8px" }}
                                                  defaultValue="+62"
                                                  disabled
                                                />
                                                <Input
                                                  status={
                                                    error?.recipient_phone
                                                      ? "error"
                                                      : ""
                                                  }
                                                  placeholder="Type Recipient's Phone"
                                                  className="mt-[8px] h-[47px] w-[480px]"
                                                  defaultValue={el.recipient_phone.replace('+62-', '')}
                                                  onChange={(value) =>
                                                    handleChangeAddress(
                                                      value,
                                                      i,
                                                      "recipient_phone"
                                                    )
                                                  }
                                                />
                                              </Space.Compact>
                                              <div className="text-red-100 text-[12px]">
                                                {error?.recipient_phone}
                                              </div>
                                            </div>
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-base font-medium">
                                                {t("CUSTOMER:CUSTOMER_COUNTRY")}
                                              </label>
                                              <Select
                                        className="w-[500px]"
                                        status={
                                          error?.country_id ? "error" : ""
                                        }
                                        dropdownStyle={{
                                          backgroundColor: "white",
                                        }}
                                        size="large"
                                        onChange={(value) =>
                                          handleChangeAddress(
                                            value,
                                            i,
                                            "country_id"
                                          )
                                        }
                                        // options={country}
                                        value={el.country_id}
                                        dropdownRender={(menu) =>
                                          dropdownCustom(
                                            menu,
                                            (value) => onChangeCountry(value),
                                            searchValue
                                          )
                                        }
                                      >
                                        {!loading
                                          ? country
                                          : [...country, LoadingOption()]}
                                      </Select>
                                              <div className="text-red-100">
                                                {error?.country_id}
                                              </div>
                                            </div>
                                            {/* <div className="w-[500px] mb-[24px]">
                                      <label className="font-roboto text-base font-medium">
                                        {t("CUSTOMER:CUSTOMER_ISLAND")}
                                      </label>
                                      <Select
                                        className="w-[500px]"
                                        status={error?.island_id ? "error" : ""}
                                        dropdownStyle={{
                                          backgroundColor: "white",
                                        }}
                                        size="large"
                                        onChange={(value) =>
                                          handleChangeAddress(
                                            value,
                                            i,
                                            "island_id"
                                          )
                                        }
                                        options={island}
                                        value={el.island_id ? el.island_id : el.islandId}
                                      
                                        disabled={el.country_id ? !el.country_id : !el.countryId}
                                      />
                                    </div> */}
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-base font-medium">
                                                {t("CUSTOMER:CUSTOMER_PROVINCE")}
                                              </label>
                                              <Select
                                        className="w-[500px]"
                                        status={
                                          error?.province_id ? "error" : ""
                                        }
                                        dropdownStyle={{
                                          backgroundColor: "white",
                                        }}
                                        size="large"
                                        onChange={(value) =>
                                          handleChangeAddress(
                                            value,
                                            i,
                                            "province_id"
                                          )
                                        }
                                        disabled={!el.country_id}
                                        // options={province}
                                        value={el.province_id}// options={province}
                                        onPopupScroll={(e) => onScrollProvince(e)}
                                        loading={loading}
                                        // options={Province}
                                        placeholder="Select Province"
                                        dropdownRender={(menu) =>
                                          dropdownCustom(
                                            menu,
                                            (value) => onChangeProvince(value),
                                            searchValue
                                          )
                                        }
                                      >
                                        {!loading ? province : [...province, LoadingOption()]}
                                      </Select>
                                              <div className="text-red-100">
                                                {error?.province_id}
                                              </div>
                                            </div>
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-base font-medium">
                                                {t("CUSTOMER:CUSTOMER_DISTRICT")}
                                              </label>
                                              <Select
                                        className="w-[500px]"
                                        status={
                                          error?.district_id ? "error" : ""
                                        }
                                        dropdownStyle={{
                                          backgroundColor: "white",
                                        }}
                                        size="large"
                                        onChange={(value) =>
                                          handleChangeAddress(
                                            value,
                                            i,
                                            "district_id"
                                          )
                                        }
                                        // options={district}
                                        value={el.district_id}
                                        disabled={!el.province_id}
                                        onPopupScroll={(e) => onScrollDistrict(e)}
                                        loading={loading}
                                        // options={District}
                                        placeholder="Select District"
                                        dropdownRender={(menu) =>
                                          dropdownCustom(
                                            menu,
                                            (value) => onChangeDistrict(value),
                                            searchValue
                                          )
                                        }
                                      >
                                        {!loading ? district : [...district, LoadingOption()]}
                                      </Select>
                                              <div className="text-red-100">
                                                {error?.district_id}
                                              </div>
                                            </div>
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-base font-medium">
                                                {t("CUSTOMER:CUSTOMER_SUB_DISTRICT")}
                                              </label>
                                              <Select
                                        className="w-[500px]"
                                        status={
                                          error?.sub_district_id ? "error" : ""
                                        }
                                        dropdownStyle={{
                                          backgroundColor: "white",
                                        }}
                                        size="large"
                                        onChange={(value) =>
                                          handleChangeAddress(
                                            value,
                                            i,
                                            "sub_district_id"
                                          )
                                        }
                                        // options={subdistrict}
                                        value={el.sub_district_id}
                                        disabled={!el.district_id}
                                        onPopupScroll={(e) => onScrollSubdistrict(e)}
                                        loading={loading}
                                        // options={Subdistrict}
                                        placeholder="Select Subdistrict"
                                        dropdownRender={(menu) =>
                                          dropdownCustom(
                                            menu,
                                            (value) => onChangeSubdistrict(value),
                                            searchValue
                                          )
                                        }
                                      >
                                        {!loading ? subdistrict : [...subdistrict, LoadingOption()]}
                                      </Select>
                                              <div className="text-red-100">
                                                {error?.sub_district_id}
                                              </div>
                                            </div>
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-base font-medium">
                                                {t("CUSTOMER:CUSTOMER_URBAN_VILLAGE")}
                                              </label>
                                              <Select
                                        className="w-[500px]"
                                        status={
                                          error?.urban_village_id ? "error" : ""
                                        }
                                        dropdownStyle={{
                                          backgroundColor: "white",
                                        }}
                                        size="large"
                                        onChange={(value) =>
                                          handleChangeAddress(
                                            value,
                                            i,
                                            "urban_village_id"
                                          )
                                        }
                                        value={el.urban_village_id}
                                        disabled={!el.sub_district_id}
                                        onPopupScroll={(e) => onScrollUrbanvillage(e)}
                                        loading={loading}
                                        // options={Urbanvillage}
                                        placeholder="Select depot Urbanvillage"
                                        dropdownRender={(menu) =>
                                          dropdownCustom(
                                            menu,
                                            (value) => onChangeUrbanvillage(value),
                                            searchValue
                                          )
                                        }
                                      >
                                        {!loading ? urbanvillage : [...urbanvillage, LoadingOption()]}
                                      </Select>
                                              <div className="text-red-100">
                                                {error?.urban_village_id}
                                              </div>
                                            </div>
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-base font-medium">
                                                {t("CUSTOMER:CUSTOMER_ADDRESS")}
                                              </label>
                                              <Input
                                                placeholder="Type Customer Address"
                                                status={error?.address || isMax ? "error" : ""}
                                                className="mt-[8px] h-[47px] w-[500px]"
                                                onChange={(value) =>
                                                  handleChangeAddress(
                                                    value,
                                                    i,
                                                    "address"
                                                  )
                                                }
                                                onBlur={() => actionBlur(i)}
                                                value={el.address}
                                              />
                                              <div className="text-red-100">
                                                {error?.address || isMax ? "The Address you entered exceeds the coverage area (" + radius + " Km)" : ""}
                                              </div>
                                            </div>
                                          </div>

                                          {/* LINE TWO */}
                                          <div className="gap-[40px] mb-[24px] ml-36">
                                            <div className="w-[500px] mb-[24px] flex">
                                              <div>
                                                <label className="font-roboto text-[16px] font-medium">
                                                  {t("CUSTOMER:HAMLET")} <i>(Optional)</i>
                                                </label>
                                                <Input
                                                  status={error?.hamlet ? "error" : ""}
                                                  placeholder="Type Hamlet"
                                                  className="mt-[8px] h-[47px] w-[200px]"
                                                  onChange={(value) =>
                                                    handleChangeAddress(
                                                      value,
                                                      i,
                                                      "hamlet"
                                                    )
                                                  }
                                                  value={el.hamlet}
                                                />
                                                <div className="text-red-100">
                                                  {error?.hamlet}
                                                </div>
                                              </div>
                                              <div>
                                                <label className="font-roboto text-[16px] font-medium">
                                                  {t("CUSTOMER:NEIGHBOURHOOD")} <i>(Optional)</i>
                                                </label>
                                                <Input
                                                  status={
                                                    error?.neighbourhood ? "error" : ""
                                                  }
                                                  placeholder="Type Neighbourhood"
                                                  className="mt-[8px] h-[47px] w-[200px]"
                                                  onChange={(value) =>
                                                    handleChangeAddress(
                                                      value,
                                                      i,
                                                      "neighbourhood"
                                                    )
                                                  }
                                                  value={el.neighbourhood}
                                                />
                                                <div className="text-red-100">
                                                  {error?.neighbourhood}
                                                </div>
                                              </div>
                                            </div>
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-base font-medium">
                                                {t("CUSTOMER:POSTAL_CODE")}
                                              </label>
                                              <Input
                                                status={
                                                  error?.postal_code || errPostal ? "error" : ""
                                                }
                                                onBlur={() => onBlurPostal()}
                                                placeholder="Type Postal Code"
                                                className="mt-[8px] h-[47px] w-[500px]"
                                                value={el.postal_code}
                                                onChange={(value) =>
                                                  handleChangeAddress(
                                                    value,
                                                    i,
                                                    "postal_code"
                                                  )
                                                }
                                              />
                                              <div className="text-red-100">
                                                {error?.postal_code || errPostal}
                                              </div>
                                            </div>
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-base font-medium">
                                                {t("CUSTOMER:LONGITUDE")}
                                              </label>
                                              <Input
                                                status={error?.longitude ? "error" : ""}
                                                placeholder="Type Longitude"
                                                className="mt-[8px] h-[47px] w-[500px]"
                                                onChange={(value) =>
                                                  handleChangeAddress(
                                                    value,
                                                    i,
                                                    "longitude"
                                                  )
                                                }
                                                value={el.longitude}
                                              />
                                              <div className="text-red-100">
                                                {error?.longitude}
                                              </div>
                                            </div>
                                            <div className="w-[500px] mb-[24px]">
                                              <label className="font-roboto text-base font-medium">
                                                {t("CUSTOMER:LATITUDE")}
                                              </label>
                                              <Input
                                                status={error?.latitude ? "error" : ""}
                                                placeholder="Type Latitude"
                                                className="mt-[8px] h-[47px] w-[500px]"
                                                onChange={(value) =>
                                                  handleChangeAddress(
                                                    value,
                                                    i,
                                                    "latitude"
                                                  )
                                                }
                                                value={el.latitude}
                                              />
                                              <div className="text-red-100">
                                                {error?.latitude}
                                              </div>
                                            </div>
                                            <div className="w-[500px] mb-[100px]">
                                              <label className="font-roboto text-base font-medium">
                                                {t("CUSTOMER:PINPOIN")}
                                              </label>
                                              <div className="w-[500px] mb-[24px] h-20">
                                                {!load ? (
                                                  <>
                                                    <MapsSmall
                                                      long={el.longitude}
                                                      lat={el.latitude}
                                                      onClicks={() =>
                                                        getAdr(el.longitude,el.latitude)
                                                      }
                                                    />
                                                  </>
                                                ) : (
                                                  <>
                                                    <Spin size="large" margin={10} />
                                                  </>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex flex-row-reverse gap-[16px] pb-8 mr-8">
                                    <button
                                      className="min-w-[87px] h-[44px] gap-3 px-[16px] bg-[#CF0000] text-white-100 text-xl flex items-center justify-evenly rounded-md"
                                      onClick={() => addAddress(i)}
                                    >
                                      Add
                                    </button>
                                    <button
                                      onClick={() => removeAddress(i)}
                                      className="w-[87px] h-[44px] text-[#CF0000] border-[2px] border-[#CF0000] bg-white-100 text-xl flex items-center justify-evenly rounded-md"
                                    >
                                      Delete
                                    </button>
                                  </div>
                                </>
                              ) : null}
                            </>
                          }
                        />
                      </div>
                    </>
                    : <></>
                }
              </>
            );
          })}

          <div className="p-5" style={{ marginBottom: "20px", width: "100%" }}>
            <div
              className={`h-[40px] ${add ? "bg-red-100" : "bg-gray-100"
                }  opacity-100 rounded-lg cursor-pointer justify-center flex`}
              onClick={add ? () => addRows() : ""}
            >
              <img src={AddIcon} alt="add" />
              <div className="text-white-100 font-semibold text-2xl ml-2 mt-1">
                Add New Address
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-row-reverse gap-[16px]">
          <PrimaryButton
            text={t("USER_DETAIL:SAVE")}
            action={changeAddress ? "" : () => onSubmit()}
            styles={`${changeAddress ? " bg-gray-100" : ""}`}
          />
          <SecondaryButton
            action={
              change
                ? () => setShowConfirm(true)
                : () => navigate(ROUTES.CUSTOMER.LIST)
            }
            text={t("USER_DETAIL:CANCEL")}
          />
        </div>
      </div>
    </>
  );
};
export default CustomerEdit;
